module.exports = __webpack_public_path__ + "img/1.70a6fd21.png";